import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ACCENT, SURFACE, TEXT } from "../../dark-theme/palette";
import { usePagesTranslation } from "../locales";

const ITEMS = [
    {
        value: "/tutors",
        labelKey: "nav.tutors-home",
        fallback: "Tutor Hub",
        match: (pathname) =>
            pathname === "/tutors"
            || pathname.startsWith("/tutors/groups")
            || pathname.startsWith("/tutors/dashboard"),
    },
    {
        value: "/tutors/library",
        labelKey: "nav.tutors-library",
        fallback: "Story library",
        match: (pathname) => pathname.startsWith("/tutors/library"),
    },
    {
        value: "/tutors/worksheets",
        labelKey: "nav.tutors-worksheets",
        fallback: "Worksheet generator",
        match: (pathname) => pathname.startsWith("/tutors/worksheets"),
    },
    {
        value: "/tutors/settings",
        labelKey: "nav.tutors-settings",
        fallback: "Settings",
        match: (pathname) => pathname.startsWith("/tutors/settings"),
    },
    {
        value: "/support",
        labelKey: "nav.tutors-support",
        fallback: "Support",
        match: (pathname) => pathname === "/support" || pathname.startsWith("/support/"),
    },
];

export default function TutorsSubNav() {
    const { t } = usePagesTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const current = ITEMS.find((item) => item.match(location.pathname))?.value || false;

    return (
        <Box
            sx={{
                borderBottom: 1,
                borderColor: SURFACE.border,
                bgcolor: SURFACE.chrome,
                px: { xs: 1, sm: 2 },
            }}
        >
            <Tabs
                value={current}
                onChange={(_, value) => navigate(value)}
                variant="scrollable"
                scrollButtons="auto"
                aria-label={t("nav.tutors-home", "Tutor Hub")}
                sx={{
                    minHeight: 48,
                    "& .MuiTab-root": {
                        minHeight: 48,
                        minWidth: 44,
                        px: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        color: TEXT.secondary,
                    },
                    "& .Mui-selected": {
                        color: ACCENT.light,
                    },
                    "& .MuiTabs-indicator": {
                        bgcolor: ACCENT.main,
                    },
                }}
            >
                {ITEMS.map((item) => (
                    <Tab
                        key={item.value}
                        value={item.value}
                        label={t(item.labelKey, item.fallback)}
                    />
                ))}
            </Tabs>
        </Box>
    );
}
